export var SET_EDIT_LONG_READ = 'SET_EDIT_LONG_READ';
export function setEditLongRead(status, num, lgId) {
    return function (dispatch) {
        dispatch({
            type: SET_EDIT_LONG_READ,
            payload: {
                data: { status: status, num: num },
                lgId: lgId
            },
        });
    };
}
//# sourceMappingURL=setEditLongRead.js.mapexport var SET_EDIT_LONG_READ = 'SET_EDIT_LONG_READ';
export function setEditLongRead(status, num, lgId) {
    return function (dispatch) {
        dispatch({
            type: SET_EDIT_LONG_READ,
            payload: {
                data: { status: status, num: num },
                lgId: lgId
            },
        });
    };
}
//# sourceMappingURL=setEditLongRead.js.map